import { type Component } from 'vue';

import AemuiFindALocation from './find-a-location/FindALocation.vue';
import AemuiLazyloadComponent from './lazyload-component/LazyloadComponent.vue';
import AemuiLeadForm from './lead-form/leadForm.vue';
import AemuiNewMemberExperiences from './new-member-experiences/NewMemberExperiences.vue';
import AemuiPartnershipMarketingForm from './partnership-marketing-form/PartnershipMarketingForm.vue';
import AemuiScheduleATour from './schedule-a-tour/scheduleATour.vue';
import AemuiWellnessForm from './wellness-form/wellnessForm.vue';

export default {
	AemuiFindALocation,
	AemuiLazyloadComponent,
	AemuiLeadForm,
	AemuiNewMemberExperiences,
	AemuiPartnershipMarketingForm,
	AemuiScheduleATour,
	AemuiWellnessForm
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
} as { [key: string]: Component<any, any, any, any, any> };
